var map = {
	"./icon-close.svg": "3c76",
	"./icon-info.svg": "1531",
	"./icon-plus.svg": "77ea",
	"./school-header-old.svg": "54c5",
	"./school-header.svg": "3e24",
	"./survey-banner-mobile.svg": "70bf",
	"./survey-banner.svg": "7c4e",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";